// extracted by mini-css-extract-plugin
export default {"contextTitle":"ContextTitle_contextTitle__a1xg4","title":"ContextTitle_title__28-fE","desc":"ContextTitle_desc__Dj09d"};